import React from 'react';
import PropTypes from 'prop-types';

import {
  Link,
  IconLogo,
  TranslationProvider,
} from '@resy/ui-kitchen';

import GreenCheck from '../../../images/icons/checkmark-success.svg';

const RatingFormThanks = ({ venue, rating, renderStars }) => (
  <div className="RatingForm RatingForm__thanks">
    <div className="RatingForm__head RatingForm__row">
      <IconLogo />
      <GreenCheck width={50} height={50} />
      <TranslationProvider translationKey="rate_reservation_complete_header">
        <h1>Thanks!</h1>
      </TranslationProvider>
      {
        rating === 1
        && (
          <TranslationProvider
            translationKey="rate_reservation_complete_body_singular"
            translationValues={{
              venueName: venue,
              rating,
            }}
          >
            <p>
              {`You rated ${venue} ${rating} star.`}
            </p>
          </TranslationProvider>
        )
      }
      {
        rating > 1
        && (
          <TranslationProvider
            translationKey="rate_reservation_complete_body_plural"
            translationValues={{
              venueName: venue,
              rating,
            }}
          >
            <p>
              {`You rated ${venue} ${rating} stars.`}
            </p>
          </TranslationProvider>
        )
      }
    </div>
    <div className="RatingForm__rating RatingForm__row">
      <div className="RatingForm__rating-stars">
        {renderStars(true)}
      </div>
    </div>
    <div className="RatingForm__ctas RatingForm__row">
      <TranslationProvider translationKey="rate_link_to_home">
        <Link
          lg
          variant="button-primary"
          href="/"
        >
          Go to the Home Page
        </Link>
      </TranslationProvider>
      <TranslationProvider translationKey="rate_link_to_reservations">
        <Link
          lg
          variant="button-secondary"
          href="/account/reservations-and-notify"
        >
          Go to Reservations
        </Link>
      </TranslationProvider>
    </div>
  </div>
);

RatingFormThanks.propTypes = {
  venue: PropTypes.string,
  rating: PropTypes.number,
  renderStars: PropTypes.func,
};

RatingFormThanks.defaultProps = {
  venue: null,
  rating: null,
  renderStars: () => {},
};

RatingFormThanks.displayName = 'RatingForm';
export default RatingFormThanks;
